import { Controller } from "@hotwired/stimulus"

const CUSTOM_VALUE = "__custom__"

export default class extends Controller {
  static targets = ["select", "custom"]

  choose() {
    const value = this.selectTarget.value

    if (value === CUSTOM_VALUE) {
      this.customTarget.value = ""
      this.customTarget.classList.remove("hidden")
      this.customTarget.focus()
      return
    }

    this.customTarget.value = value
    this.customTarget.classList.add("hidden")
  }
}
